import PortalIdParser from 'PortalIdParser';
export const getHubDbUrl = () => `/hubdb/${PortalIdParser.get()}`;
export const getHubDbTableUrl = tableId => `${getHubDbUrl()}/table/${tableId}`;